<template>
  <div>
    <h1 class="page-header">
      Product Assembly
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> Account Number</label>
              <div class="col-md-7">
                <input
                  type="number"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('account_number') }"
                  v-model.number="model.account_number"
                  ref="account_number"
                  placeholder="Enter account number"
                />
                <div class="invalid-feedback" v-if="errors.has('account_number')">
                  {{ errors.first('account_number') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Account Name <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <input
                  v-model="model.account_name"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('account_name') }"
                  placeholder="Enter account name"
                />
                <div class="invalid-feedback" v-if="errors.has('account_name')">
                  {{ errors.first('account_name') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Account Type <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <select
                  v-model.number="model.account_type_id"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('account_type_id') }"
                >
                  <option value="">--select--</option>
                  <option
                    v-for="(account_type, index) in account_types"
                    :key="index"
                    :value="account_type.account_type_id"
                  >
                    {{ account_type.account_type }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('account_type_id')">
                  {{ errors.first('account_type_id') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Parent Account
              </label>
              <div class="col-md-7">
                <select
                  v-model.number="model.parent_account_id"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('parent_account_id') }"
                >
                  <option value="">--select--</option>
                  <option
                    v-for="(parent_account, index) in parent_accounts"
                    :key="index"
                    :value="parent_account.account_id"
                  >
                    {{ parent_account.account_name }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('parent_account_id')">
                  {{ errors.first('parent_account_id') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Description
              </label>
              <div class="col-md-7">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="model.description"
                  placeholder="Leave your description here..."
                  :class="{ 'is-invalid': errors.has('description') }"
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('description')">
                  {{ errors.first('description') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Notes
              </label>
              <div class="col-md-7">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="model.notes"
                  placeholder="Leave your notes here..."
                  :class="{ 'is-invalid': errors.has('notes') }"
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('notes')">
                  {{ errors.first('notes') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-15">
              <label class="col-md-5 col-form-label control-label "></label>
              <div class="col-md-7">
                <div class="checkbox checkbox-css checkbox-inline">
                  <input type="checkbox" id="is_sub_account" v-model="model.is_sub_account" />
                  <label for="is_sub_account">Sub Account</label>
                </div>
                <div class="checkbox checkbox-css checkbox-inline">
                  <input type="checkbox" id="inactive" v-model="model.inactive" />
                  <label for="inactive">Inactive</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row  text-right">
          <div class="col-lg-12">
            <ts-button class="ml-2" color="primary" :waiting="saving" @click="update">
              Update
            </ts-button>

            <ts-button class="ml-2" @click="$router.push({ name: 'chart-of-account' })">
              Cancel
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'chart-of-account-edit',
  props: ['chartOfAccount'],
  data() {
    return {
      model: _.cloneDeep(this.chartOfAccount),
      saving: false,
      errors: new Errors()
    }
  },
  mounted() {
    this.$refs.account_number.focus()
  },
  created() {},
  computed: {
    ...mapState('accounting/chartOfAccount', ['account_types', 'parent_accounts'])
  },
  methods: {
    update() {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('accounting/chartOfAccount/update', Object.assign({}, this.model))
        .then(respons => {
          this.$toasted.success(respons.message)
          this.$router.push({ name: 'chart-of-account' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    },
    clearForm() {
      this.model.account_number = ''
      this.model.account_name = ''
      this.model.account_type_id = ''
      this.model.is_sub_account = false
      this.model.parent_account_id = ''
      this.model.description = ''
      this.model.notes = ''
      this.model.inactive = false
    }
  }
}
</script>
